<template>
  <div class="box">
    <el-container>
      <el-header>
        <div class="header-box">
          <h2>个人博客后台</h2>
          <div class="userinfo-box">
            <div class="username">长白一梦</div>
            <el-button type="danger" @click="onExit" size="small">退出</el-button>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside :width="collapseStatus ? '64px' : '200px'">
          <!-- 折叠按钮 -->
          <el-tooltip class="item" effect="dark" :content="collapseStatus ? '展开' : '折叠'" placement="right">
            <div class="fold-button" @click="onCollapse">|||</div>
          </el-tooltip>
          <!-- 左侧菜单 -->
          <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :collapse="collapseStatus"
            :collapse-transition="false" router :unique-opened="true">
            <el-menu-item index="/userinfo">
              <i class="el-icon-user-solid"></i>
              <span>博主信息</span>
            </el-menu-item>
            <el-menu-item index="/articleType">
              <i class="el-icon-paperclip"></i>
              <span>文章类型</span>
            </el-menu-item>
            <el-menu-item index="/articleLabel">
              <i class="el-icon-brush"></i>
              <span>文章标签</span>
            </el-menu-item>
            <el-menu-item index="/article">
              <i class="el-icon-document"></i>
              <span>文章管理</span>
            </el-menu-item>
            <el-menu-item index="/myProject">
              <i class="el-icon-folder-opened"></i>
              <span>个人项目</span>
            </el-menu-item>
            <el-submenu index="">
              <template slot="title">
                <i class="el-icon-s-promotion"></i>
                <span>友链管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/links">全部友链</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="/auditLinks">友链审核</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="/message">
              <i class="el-icon-s-comment"></i>
              <span>留言板</span>
            </el-menu-item>
            <el-menu-item index="/about">
              <i class="el-icon-s-opportunity"></i>
              <span>关于博客</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      collapseStatus: false,
    };
  },
  methods: {
    onExit() {
      window.sessionStorage.clear();
      this.$router.push("/login");
      this.$message.success("退出成功");
    },
    onCollapse() {
      this.collapseStatus = !this.collapseStatus
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
}

.el-header {
  background-color: rgb(84, 92, 100);

  .header-box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
      display: block;
      color: #f8f8f8;
    }

    .userinfo-box {
      display: flex;
      align-items: center;

      .username {
        font-size: 18px;
        color: #f8f8f8;
        text-decoration: underline;
        margin-right: 20px;
      }

    }
  }
}

.el-container {
  height: 100%;
}

.el-aside {
  width: 100%;
  height: 100%;
  background-color: rgb(84, 92, 100);

  .fold-button {
    background: #303133;
    text-align: center;
    letter-spacing: 4px;
    padding: 10px 0;
    cursor: pointer;
    color: #f8f8f8;
  }

  .el-menu {
    border-right: none;
  }
}

.el-main {
  background-color: #eaedf1;
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue